<p
    class="product-attribute-font-description paragraph-small"
    [innerHTML]="inputDescription"
    [class.truncated]="isTruncated"
    #descriptionElement>
</p>

@if (showToggle) {
<button class="see-more-link" (click)="toggleDescription()">
    @if (isTruncated) {

    <ng-container *ngTemplateOutlet="showMore"></ng-container>

    } @else {
    <span i18n="@@hermes-global-translations.less-detail" class="paragraph-small">See less</span>
    }
    <ng-template #showMore>
        <span i18n="@@hermes-global-translations.expand" class="paragraph-small">See more</span></ng-template
    >
</button>
}
